import TranslationKeysTable from "./translation-keys-table";

export default TranslationKeysTable;
